import React from 'react';
import Grid from '@material-ui/core/Grid';
import FontEditor from './fontEditor';
import TransitionEditor from './transitionEditor';
import BackgroundEditor from './backgroundEditor';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import './motionController.scss';

const MotionController = props => {
  const {
    fontOptions,
    onFontOptionsChange,
    transitionOptions,
    onTransitionOptionsChange,
    backgroundOptions,
    onBackgroundOptionsChange,
    galleryMode,
  } = props

  return (
    <div className="motion-controller">
      <Grid
        container
        direction="column"
        justify="space-between"
        alignItems="center"
      >
        <div style={{ width: '100%' }}>
          
        {!galleryMode && (        
          <ExpansionPanel className="expansion-panel">
            <ExpansionPanelSummary 
              classes={{ root: 'expansion-panel-summary', expanded: 'expanded' }}
              expandIcon={<ExpandMoreIcon />}
            >
              Easing Options
            </ExpansionPanelSummary>
            <ExpansionPanelDetails
              classes={{ root: 'expansion-panel-details'}}
            >
            <TransitionEditor
                transitionOptions={transitionOptions}
                onTransitionOptionsChange={onTransitionOptionsChange}
              />
            </ExpansionPanelDetails>
          </ExpansionPanel>
      )}

          <ExpansionPanel className="expansion-panel">
          <ExpansionPanelSummary 
              classes={{ root: 'expansion-panel-summary', expanded: 'expanded' }}
              expandIcon={<ExpandMoreIcon />}
            >
              Font Options
            </ExpansionPanelSummary>
            <ExpansionPanelDetails
              classes={{ root: 'expansion-panel-details'}}
            >
              <FontEditor
                onChange={onFontOptionsChange}
                fontOptions={fontOptions}
              />
            </ExpansionPanelDetails>
          </ExpansionPanel>

          {!galleryMode && (
            <ExpansionPanel className="expansion-panel">
            <ExpansionPanelSummary 
              classes={{ root: 'expansion-panel-summary', expanded: 'expanded' }}
              expandIcon={<ExpandMoreIcon />}
            >
              Background Options
            </ExpansionPanelSummary>
              <ExpansionPanelDetails
                classes={{ root: 'expansion-panel-details'}}
              >
                <BackgroundEditor
                  backgroundOptions={backgroundOptions}
                  onBackgroundOptionsChange={onBackgroundOptionsChange}
                />
              </ExpansionPanelDetails>
            </ExpansionPanel>
          )}

        </div>        
      </Grid>
    </div>
  )
}

export default MotionController
